import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  chooseProductToLink: () => __(translations.commercialDocumentComponents.chooseProductToLink, 'Choose product to link'),
};
